import DeleteFrame from "./DeleteFrame";

export default DeleteFrame